import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { AllocationLoderComponent } from "../view/allocation-loder/allocation-loder.component";
import { TabSetComponent } from "../view/tab-set/tab-set.component";
import { PaginationComponent } from "../template/pagination/pagination.component";
import { SearchComponent } from "../template/search/search.component";
import { NgxPaginationModule } from "ngx-pagination";
import { SharedOrderModelComponent } from "../shared-order-model/shared-order-model.component";
import { FormsModule } from "@angular/forms";
import { AppFooterComponent } from "../template/app-footer/app-footer.component";
import { AppRoutingModule } from "../app-routing.module";
import { RouterModule } from "@angular/router";
import { InputMaxLengthDirective } from "../directive/input-max-length.directive";
import { NoNegativeDirective } from "../view/directive/negative.directive";
import { NumbersOnlyDirective } from "../view/directive/numbers-only.directive";
import { ImageCropperModule } from "ngx-image-cropper";
import { AdvancedFilterComponent } from "../view/advanced-filter/advanced-filter.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { AddressAutocompleteComponent } from "./address-autocomplete/address-autocomplete.component";
import { CartItemsComponent } from "../manage-cart/cart-items/cart-items.component";
import { StoreFilterDropdownComponent } from "../stock-management/store-filter-dropdown/store-filter-dropdown.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { AllocationExceedModelComponent } from "../products/allocation-exceed-model/allocation-exceed-model.component";
import { DecimalOnlyDirective } from "../view/directive/decimal.directive";
import { FileAcceptPipe } from "./file-accept.pipe";

@NgModule({
  declarations: [
    AllocationLoderComponent,
    TabSetComponent,
    PaginationComponent,
    SearchComponent,
    SharedOrderModelComponent,
    AppFooterComponent,
    InputMaxLengthDirective,
    NoNegativeDirective,
    DecimalOnlyDirective,
    NumbersOnlyDirective,
    AdvancedFilterComponent,
    AddressAutocompleteComponent,
    CartItemsComponent,
    StoreFilterDropdownComponent,
    AllocationExceedModelComponent,
    FileAcceptPipe,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    NgxPaginationModule,
    FormsModule,
    RouterModule,
    ImageCropperModule,
    NgSelectModule,
    NgbTooltip,
  ],
  providers: [],
  exports: [
    AllocationLoderComponent,
    TabSetComponent,
    PaginationComponent,
    SearchComponent,
    SharedOrderModelComponent,
    AllocationExceedModelComponent,
    CommonModule,
    NgxPaginationModule,
    FormsModule,
    AppFooterComponent,
    InputMaxLengthDirective,
    NoNegativeDirective,
    NumbersOnlyDirective,
    ImageCropperModule,
    AdvancedFilterComponent,
    AddressAutocompleteComponent,
    CartItemsComponent,
    StoreFilterDropdownComponent,
    NgbTooltip,
    DecimalOnlyDirective,
    FileAcceptPipe
  ],
})
export class UIModule {}
